import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import { ContextApi } from "./contextApi/ContextApi";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ContextApi>
    <BrowserRouter>

        <App />
 
    </BrowserRouter>
  </ContextApi>
);
